import {CanActivateChildFn, Router} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {inject, Signal} from '@angular/core';
import {User} from 'patja-api';
import {firstValueFrom} from 'rxjs';
import {RoutePaths} from '../../app.routes';
import {CompaniesService} from '../services/companies.service';

export const isUsingReceiptsGuard: CanActivateChildFn = async () => {
  const authService: AuthService = inject(AuthService);
  const companiesService: CompaniesService = inject(CompaniesService);
  const router: Router = inject(Router);
  const company = companiesService.getSelectedCompany();
  const user: Signal<User | null> = await firstValueFrom(authService.getUser());

  if (user()?.isCustomer()) {
    if (company()?.useAccountingMaterial) {
      await router.navigateByUrl(RoutePaths.Home);
      return false;
    }

    return true;
  }

  if (user()?.useReceipts || user()?.isAccountingOfficeAdmin()) {
    return true;
  }

  await router.navigateByUrl(RoutePaths.Home);
  return false;
};
